import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import Text from '@polestar/component-warehouse-react/components/text/Text';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
import LetterSpacings from '@polestar/component-warehouse-react/tokens/letter-spacings/LetterSpacings';
export const HeadingVariantSizes = {
    [Sizes.small]: {
        fontSize: FontSizes.body,
        letterSpacing: LetterSpacings.small,
        lineHeight: LineHeights.small,
    },
    [Sizes.medium]: {
        fontSize: FontSizes.large,
        letterSpacing: LetterSpacings.large,
        lineHeight: LineHeights.large,
    },
};
const StyledText = styled(Text)(({ theme, accent, isMultiline }) => {
    return css `
    color: ${accent ? theme.heading.accent : ''};
    ${isMultiline ? 'white-space: pre-wrap;' : ''}
  `;
});
const Heading = forwardRef(({ level = 1, size = Sizes.medium, accent = false, children, isMultiline = false, ...props }, ref) => {
    return (React.createElement(StyledText, { ref: ref, as: `h${level}`, accent: accent, variant: HeadingVariantSizes[size], isMultiline: isMultiline, ...props }, children));
});
Heading.displayName = 'Heading';
export default Heading;
export const H1 = forwardRef((props, ref) => (React.createElement(Heading, { level: 1, ref: ref, ...props })));
H1.displayName = 'H1';
export const H2 = forwardRef((props, ref) => (React.createElement(Heading, { level: 2, ref: ref, ...props })));
H2.displayName = 'H2';
export const H3 = forwardRef((props, ref) => (React.createElement(Heading, { level: 3, ref: ref, ...props })));
H3.displayName = 'H3';
export const H4 = forwardRef((props, ref) => (React.createElement(Heading, { level: 4, ref: ref, ...props })));
H4.displayName = 'H4';
export const H5 = forwardRef((props, ref) => (React.createElement(Heading, { level: 5, ref: ref, ...props })));
H5.displayName = 'H5';
export const H6 = forwardRef((props, ref) => (React.createElement(Heading, { level: 6, ref: ref, ...props })));
H6.displayName = 'H6';
